import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-MS4xNC4w--action-group{display:block;} .lsgs-MS4xNC4w--action-group:not(.lsgs-MS4xNC4w--no-margin){margin-bottom:16px;}@media screen and (min-width:1024px){ .lsgs-MS4xNC4w--action-group:not(.lsgs-MS4xNC4w--no-margin){margin-bottom:24px;}}.lsgs-MS4xNC4w--action-group-inner{margin-bottom:-16px;display:flex;flex-direction:column-reverse;flex-wrap:nowrap;}@media screen and (min-width:640px){.lsgs-MS4xNC4w--action-group-inner{justify-content:space-between;flex-direction:row;align-items:flex-start;}}@media screen and (min-width:1024px){.lsgs-MS4xNC4w--action-group-inner{margin-bottom:-24px;}}";
var hostClass = "lsgs-MS4xNC4w--action-group";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
